/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "ownbraceletevents",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,
	trigers: triggers,

	_serial: null,
	_mac: null,
	_braceletTracker: null
});

function init() {
	this._braceletTracker = this.dispatcher.createTracker();
}

function uninit() {
	this._braceletTracker.off();
	this._braceletTracker = null;
}

function triggers() {
	return {
		"subscribe": subscribeEvents,
		"unsubscribe": unsubscribeEvents,
		"alert:alert": alertBracelet,
		"alert:on": alertBraceletOn,
		"alert:off": alertBraceletOff,
		"disconnected": notifyDsiconnected,
		"disconnect": handle_bracelet_disconnect
	};
}

function listeners() {
	return {
		"machinetracker:updated": handle_machine_tracker_updated,
	};
}

function subscribeEvents(data) {
	var mac = data.mac;
	var model = data.model;
	this._mac = mac;
	this._model = model ? model : "vlrt"; // model defaults to 'vlrt' if undefined

	var cleanMac = hyphenateMac(mac);

	this._braceletTracker.off();
	this._braceletTracker.on("mqtt:bracelet/" + cleanMac + "/connected", makeEmitter(this, "connected"));
	this._braceletTracker.on("mqtt:bracelet/" + cleanMac + "/disconnected", makeEmitter(this, "disconnected"));
	this._braceletTracker.on("mqtt:bracelet/" + cleanMac + "/battery", makeEmitter(this, "battery"));

	if (model === "vlrt") {
		this._braceletTracker.on("mqtt:bracelet/" + cleanMac + "/pressed", makeEmitter(this, "pressed"));
		this._braceletTracker.on("mqtt:bracelet/" + cleanMac + "/fallen", makeEmitter(this, "fallen"));
	}

}

function unsubscribeEvents() {
	this._braceletTracker.off();
}

function alertBracelet() {
	var mac = this._mac;
	var serial = this._serial;
	if (!mac || !serial) return;
	var cleanMac = hyphenateMac(mac);
	this.emit("$mqtt:bracelet/" + cleanMac + "/alert/alert", {
		machine: serial
	});
}

function alertBraceletOn() {
	var mac = this._mac;
	var serial = this._serial;
	if (!mac || !serial) return;
	var cleanMac = hyphenateMac(mac);
	this.emit("$mqtt:bracelet/" + cleanMac + "/alert/on", {
		machine: serial
	});
}

function alertBraceletOff() {
	var mac = this._mac;
	var serial = this._serial;
	if (!mac || !serial) return;
	var cleanMac = hyphenateMac(mac);
	this.emit("$mqtt:bracelet/" + cleanMac + "/alert/off", {
		machine: serial
	});
}

function handle_bracelet_disconnect() {
	var mac = this._mac;
	if (!mac) return;
	var cleanMac = mac.replace(/:/g, "-");
	this.emit("$mqtt:bracelet/" + cleanMac + "/disconnect", {
		mac: mac
	});
}


function notifyDsiconnected(data) {
	var reason = (data || {}).reason || "unknown";

	var mac = this._mac;
	var serial = this._serial;
	if (!mac || !serial) return;
	var cleanMac = hyphenateMac(mac);

	var payload = {
		machine: serial,
		reason: reason
	};

	this.emit("$mqtt:bracelet/" + cleanMac + "/disconnected", payload);
}

function makeEmitter(model, event) {
	return function (data) {
		model.dispatch(event, data);
	};
}

function handle_machine_tracker_updated(data) {
	this._serial = data.serial;
}

function hyphenateMac(mac) {
	var cleanMac = mac.replace(/:/g, "-");
	return cleanMac;
}
